module.exports = __webpack_public_path__ + "img/imagen2.18f767f6.png";